<style scoped lang="stylus">
    @import "../assets/css/theme.styl"
    .cus-nav-bar {
        height 46px
        .nav-bar {
            background-color: baseBackColor
            ::v-deep .van-nav-bar__title, .van-icon, .van-nav-bar__text {
                color: #fff
            }
            .van-nav-bar__text:active {
                background-color: #3491fa
            }
            &:after {
                border-bottom none
            }
        }

    }
</style>

<template>
    <div class="cus-nav-bar" v-show="currRouterName != 'login'">
        <van-nav-bar
                :title="meta.title"
                :left-text="meta.hideBack ? '' : '返回'"
                :right-text="rightText"
                :left-arrow="!meta.hideBack"
                @click-left="goBack"
                @click-right="rightClick"
                class="nav-bar"
                fixed
        >
            <div slot="right">
                <span v-show="meta.rightText" style="color:#fff; margin-right: 6px;">{{meta.rightText}}</span>
                <van-icon v-show="meta.rightIcon" :name="meta.rightIcon"/>
            </div>
        </van-nav-bar>
    </div>
</template>

<script>
    export default {
        props: [],
        components: {},
        data() {
            return {};
        },
        created() {

        },
        mounted() {

        },
        computed: {
            meta() {
                return this.$route.meta;
            },
            currRouterName() {
                return this.$route.name;
            },
            rightText() {
                return this.meta.rightText ? this.meta.rightText : ''
            }
        },
        watch: {},
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            rightClick() {
                console.log('rightClick');
                this.$eventHub.$emit("click-right");
            },
        },
    };
</script>
